<template>
  <div class="content">
    <div class="row text-left">
      <div class="col-md-12">
        <p class="text-black-50">
          Новая номенклатура
          <i v-on:click="addNewOne" class="tim-icons icon-money-coins"></i>
        </p>
      </div>
    </div>
    <big-one :content="content" :type = "type" tuning="true" :a-page="true" :new-one="newOne"></big-one>
  </div>
</template>
<script>

const name = {header: "Наименование", name: "name", sort: true, show: true, contains: ""};
const code = {header: "Артикул", name: "code", sort: true, show: true, contains: ""};
const category = {header: "Категория", name: "category.name", show: true, sort: true};

export default{
  data() {
    return {
      type: "product",
      content: [name, code, category],
      newOne: null
    }
  },
  methods: {
    addNewOne() {
      let object = {id: 0};
      this.newOne = ({object: object, id: object.id, view: 'edit'});
    }
  }
}
</script>
<style>
</style>
